<mat-card (click)="cardClick()" *ngIf="card.display == 'Summary'" style="min-height: 135px; max-height: 135px; display: flex; flex-direction: row; cursor: pointer; padding: 0">
  <div [ngClass]="isDisabled()" style="display: flex; flex-direction: column; flex: .25;">
    <img *ngIf="!card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;" src="./assets/images/Card Assignments.png">
    <img *ngIf="card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;" src="./assets/images/Card Assignments disabled.png">
  </div>
  <div style="display: flex; flex-direction: column; flex: 1;">
    <div class="robotoMedium" style="display: flex; flex-direction: row; padding: 5px; flex: .25; font-size: 12pt; align-items: flex-start;">
      <span translate>Assignments</span>
    </div>
    <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; flex: 1">
      <div style="display: flex; flex-direction: column; flex: 1;">
        <div class="robotoMedium" style="display: flex; flex-direction: row;font-size: 28pt; justify-content: center;">
          {{missingCount}}
        </div>
        <div style="flex-direction: row; justify-content: center; font-size: 10pt">
            <div style="display: flex;justify-content: center;" translate>Missing in<br/>Last 30 Days</div>
            <!-- <div style="display: flex;justify-content: center;">Last 30 Days</div> -->
        </div>
      </div>
      <div style="display: flex; flex-direction: column; flex: 1;">
        <div class="robotoMedium" style="display: flex; flex-direction: row;font-size: 28pt; justify-content: center;">
          {{dueTodayCount}}
        </div>
        <div style="display: flex; flex-direction: row; justify-content: center; font-size: 10pt">
            <span style="margin-top: 19px;" translate>Due Today</span>
        </div>
      </div>
      <div style="display: flex; flex-direction: column; flex: 1;">
        <div class="robotoMedium" style="display: flex; flex-direction: row;font-size: 28pt; justify-content: center;">
          {{dueTomorrowCount}}
        </div>
        <div style="display: flex; flex-direction: row; justify-content: center; font-size: 10pt">
            <span style="margin-top: 19px;" translate>Due Tomorrow</span>
        </div>
      </div>
    </div>
    <!--If Disabled-->
    <div *ngIf="card.disabled" class="robotoMedium" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
      <div>
        {{card.disabledMessage}}
      </div>
    </div>
  </div>
</mat-card>
<mat-card *ngIf="card.display == 'Detail'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
  <div style="display: flex; flex-direction: column; flex: 1">
    <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
      <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
          <span translate>Assignments</span>
      </div>
      <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; padding: 5px">
        <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end">
          <button mat-stroked-button class="mat-card-button" (click)="viewAllClick()"><span translate>Go To Assignments</span></button>
        </div>
      </div>
    </div>
    <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; flex: 1">
      <table *ngIf="assignments.length > 0" mat-table [dataSource]="assignments" style="width: 100%">

        <!-- Due Column -->
        <ng-container matColumnDef="Due">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Due</span></th>
          <td mat-cell *matCellDef="let assignment" [ngClass]="checkIfMissing(assignment)" style="font-size: 10pt; padding-right: 10px"> {{assignment.Due}} </td>
        </ng-container>

        <!-- Class Column -->
        <ng-container matColumnDef="Class">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Class</span></th>
          <td mat-cell *matCellDef="let assignment" style="font-size: 10pt; padding-right: 10px"> {{assignment.Class}} </td>
        </ng-container>

        <!-- Assignment Column -->
        <ng-container matColumnDef="Assignment">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Assignment</span></th>
          <td mat-cell *matCellDef="let assignment" style="font-size: 10pt;"> {{assignment.AssignmentName}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="assignments.length == 0" style="display: flex; flex-direction: column; align-items: center; flex: 1; padding: 15px">
        <div style="display: flex; flex-direction: column">
          <span translate>No missing assignments in the last 30 days.</span>
        </div>
        <div style="display: flex; flex-direction: column">
            <span translate>No assignments due today or tomorrow.</span>
        </div>
      </div>
    </div>
    <div *ngIf="card.disabled" class="robotoMedium" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
      <div style="padding: 50px;">
        {{card.disabledMessage}}
      </div>
    </div>
  </div>
</mat-card>
